"use strict";

import "./TextFilter.css";
import React from "react";
import ReactDOM from "react-dom";
import Input from "vwa/components/Input";
import Button from "vwa/components/Button";
import lang from "./../../lang";

export default class TextFilter extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			value: this.props.value
		};
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.value != this.props.value) {
			this.setState({
				value: nextProps.value
			});
		}
	}
	
	submit() {
		const input = ReactDOM.findDOMNode(this.refs.input);
		this.props.onSubmit(input.value);
	}
	
	handleKeyUp(evt) {
		if (evt.keyCode == 13) {
			this.submit();
		}
	}
	
	render() {
		return (
			<div className="TextFilter">
				<div>
					<Input
						ref="input"
						value={this.state.value}
						onChange={evt => this.setState({value: evt.target.value})}
						placeholder={lang._SEARCH}
						onKeyUp={evt => this.handleKeyUp(evt)}
					/>
					<Button
						icon="magnify"
						onClick={_ => this.submit()}
					/>
				</div>
			</div>
		);
	}
	
}

TextFilter.propTypes = {
	onSubmit: React.PropTypes.func,
	value: React.PropTypes.string
};

TextFilter.defaultProps = {
	onSubmit: value => {},
	value: ""
};


// WEBPACK FOOTER //
// ./~/vwa/components/TextFilter/TextFilter.jsx